'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");

var panelColor = Css.hex("3c4046");

var titleColor = Css.hex("8f97a5");

var subTitleColor = Css.hex("78a4ec");

var textColor = Css.hex("858d9a");

var navBarColor = Css.hex("26282b");

var title = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(25)),
      tl: {
        hd: Css.color(titleColor),
        tl: {
          hd: Css.fontWeight({
                NAME: "num",
                VAL: 400
              }),
          tl: {
            hd: Css.margin4(Css.rem(2.0), "zero", Css.rem(1.2), "zero"),
            tl: /* [] */0
          }
        }
      }
    });

var label = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(20)),
      tl: {
        hd: Css.color(titleColor),
        tl: /* [] */0
      }
    });

var h3 = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(22)),
      tl: {
        hd: Css.color(Css.hex("59606a")),
        tl: {
          hd: Css.fontWeight({
                NAME: "num",
                VAL: 400
              }),
          tl: {
            hd: Css.backgroundColor(panelColor),
            tl: {
              hd: Css.padding(Css.px(21)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var weaponCategory = Curry._1(Css.style, {
      hd: Css.textTransform(Css.capitalize),
      tl: /* [] */0
    });

var green = Css.hex("4aae4a");

var red = Css.hex("ff2828");

var melee = Curry._1(Css.style, {
      hd: Css.color(Css.hex("ff8400")),
      tl: /* [] */0
    });

var magic = Curry._1(Css.style, {
      hd: Css.color(Css.hex("d24aff")),
      tl: /* [] */0
    });

var ranged = Curry._1(Css.style, {
      hd: Css.color(Css.hex("ff5656")),
      tl: /* [] */0
    });

var summoner = Curry._1(Css.style, {
      hd: Css.color(Css.hex("F7FF11")),
      tl: /* [] */0
    });

function forCategory(category) {
  switch (category) {
    case /* Melee */0 :
        return weaponCategory + " " + melee;
    case /* Magic */1 :
        return weaponCategory + " " + magic;
    case /* Ranged */2 :
        return weaponCategory + " " + ranged;
    case /* Summoner */3 :
        return weaponCategory + " " + summoner;
    
  }
}

var smallAvatar = Curry._1(Css.style, {
      hd: Css.width(Css.px(30)),
      tl: {
        hd: Css.height(Css.px(30)),
        tl: {
          hd: Css.borderRadius(Css.px(999)),
          tl: {
            hd: Css.backgroundColor(Css.hex("969696")),
            tl: {
              hd: Css.margin(Css.px(10)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var limitedWidthCard = Curry._1(Css.style, {
      hd: Css.maxWidth(Css.px(1042)),
      tl: {
        hd: Css.margin(Css.auto),
        tl: /* [] */0
      }
    });

var top = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: /* [] */0
    });

var loadMore = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(20)),
      tl: {
        hd: Css.marginTop(Css.px(50)),
        tl: {
          hd: Css.paddingBottom(Css.px(50)),
          tl: {
            hd: Css.textAlign(Css.center),
            tl: {
              hd: Css.color(subTitleColor),
              tl: {
                hd: Css.cursor(Css.pointer),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

exports.panelColor = panelColor;
exports.titleColor = titleColor;
exports.subTitleColor = subTitleColor;
exports.textColor = textColor;
exports.navBarColor = navBarColor;
exports.title = title;
exports.label = label;
exports.h3 = h3;
exports.weaponCategory = weaponCategory;
exports.green = green;
exports.red = red;
exports.melee = melee;
exports.magic = magic;
exports.ranged = ranged;
exports.summoner = summoner;
exports.forCategory = forCategory;
exports.smallAvatar = smallAvatar;
exports.limitedWidthCard = limitedWidthCard;
exports.top = top;
exports.loadMore = loadMore;
/* panelColor Not a pure module */
